import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';
import BreadCrumbs from '@/app/components/BreadCrumbs';

const appName = process.env.REACT_APP_NAME;
const hasCustomLogos = appName === 'canaleducacao' || appName === 'maiseducacao';

const dashboardContentVariants = cva('ml-0 p-4 pt-[110px] w-full max-w-screen overflow-x-hidden overflow-y-auto bg-neutral-bright bp-md:pt-[104px] bp-md:px-11 bp-md:pb-11 bp-md:ml-16 bp-md:w-[calc(100%-64px)]', {
  variants: {
    variant: {
      default: 'flex flex-col justify-start flex-wrap',
      plain: ''
    },
    minHeight: {
      default: 'min-h-screen', // 100vh
      minusHeader: 'min-h-[calc(100vh-68px)] bp-md:min-h-screen' // 100vh - 68px
    }
  },
  defaultVariants: {
    variant: 'default',
    minHeight: 'default'
  }
});

const DashboardContent = React.forwardRef(({ className, variant, breadcrumbs, breadcrumbsVerified, breadcrumbsActions, children, ...props }, ref) => {
  const minHeightVariant = hasCustomLogos ? 'minusHeader' : 'default';

  return (
    <div
      ref={ref}
      className={cn('c-dashboard-content', dashboardContentVariants({ variant, minHeight: minHeightVariant }), className)}
      {...props}
    >
      {breadcrumbs && (
        <BreadCrumbs
          data={breadcrumbs}
          innerContent={breadcrumbsVerified}
          actions={breadcrumbsActions}
        />
      )}

      {children}
    </div>
  );
});
DashboardContent.displayName = 'DashboardContent';

export { DashboardContent };
